import z from 'zod'
import { paxtonHighlightAreaSchema } from '@/components/react-pdf-viewer/schema/paxton-highlight-area'
import { TimelineSourceRefSchema } from '@/timeline/sources/schemas'

export const TimelineReferenceSchema = z.object({
  id: z.string().uuid(),
  file_path: z.string(),
  source: TimelineSourceRefSchema,
  // Backend emits 1-based page numbers; the shared viewer layer (PageCitation's `page + 1`
  // label and the PDF viewer's 0-indexed jumpToPage) expects 0-based. Convert here so the
  // sentence-citation label reads the true page and click-to-source lands on it. See the
  // matching note in events/store/schemas.ts. (Note: navigation for references that carry
  // `highlights` uses the highlight pageIndex, not this field — that path is unaffected here.)
  pages: z.array(z.number().int().nonnegative()).transform((pages) => pages.map((page) => page - 1)),
  highlights: z.array(paxtonHighlightAreaSchema),
})

export type TimelineReference = z.infer<typeof TimelineReferenceSchema>
